export const determineIfCurrentlyActive = (transactionArr) => {
    let investQty = 0;
    let currentlyActive = false;
    for (let i=0; i<transactionArr.length; i++){
        let tranQuantity = +transactionArr[i].quantity;
        if (transactionArr[i].tranType === 'sell'){
            tranQuantity = +transactionArr[i].quantity * -1;
        }
        investQty += tranQuantity;
    }
    if (investQty > 0){
        currentlyActive = true;
    }
    return currentlyActive;
}
export default determineIfCurrentlyActive;